import { initUcCommonLogin, showUcCommonLoginDialog, logoutSaasAndPassport, logoutUcAndSaas } from '@baidu/trade-util/utils/login';
import { ArrowDown, ArrowRightBold } from '@element-plus/icons-vue';
import { ElPopover, ElBadge } from 'element-plus';
import { defineComponent, toRefs, onMounted, resolveComponent, openBlock, createElementBlock, createElementVNode, renderSlot, createBlock, withCtx, createVNode, createTextVNode, toDisplayString, Fragment, createCommentVNode, renderList } from 'vue';
import { bmsUserMenuProps } from './bms-user-menu2.js';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "UserMenu",
  components: {
    ElPopover,
    ArrowDown,
    ArrowRightBold,
    ElBadge
  },
  props: bmsUserMenuProps,
  emits: [
    "request-logout",
    "request-login"
  ],
  setup(props, { emit }) {
    const { ucCommonConfig } = toRefs(props);
    const initLogin = async () => {
      var _a, _b, _c;
      await initUcCommonLogin(!!((_a = ucCommonConfig.value) == null ? void 0 : _a.isProd), {
        appid: (_b = ucCommonConfig == null ? void 0 : ucCommonConfig.value) == null ? void 0 : _b.appid,
        product: (_c = ucCommonConfig == null ? void 0 : ucCommonConfig.value) == null ? void 0 : _c.product,
        isLayer: 1,
        defaultCss: false,
        onRender: () => {
          var _a2;
          const closeCommonLoginLayerDom = document.querySelector("#common-login .close-common-login-layer");
          if (closeCommonLoginLayerDom) {
            closeCommonLoginLayerDom.innerHTML = `
                            <svg t="1653906940860" version="1.1" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" p-id="1682" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24">
                                <path d="M285.59783 285.59783a42.666667 42.666667 0 0 1 60.339779 0l165.904221 165.904221 165.934391-165.934391a42.666667 42.666667 0 1 1 60.339779 60.339779l-165.934391 165.934391 165.934391 165.934391a42.666667 42.666667 0 1 1-60.339779 60.339779l-165.934391-165.934391-165.934391 165.934391a42.666667 42.666667 0 1 1-60.339779-60.339779l165.934391-165.934391-165.934391-165.934391a42.666667 42.666667 0 0 1 0-60.339779z" p-id="1683"></path>
                            </svg>
                        `;
          }
          const loginActionBtnDom = document.querySelector("form#uc-login .login-action");
          const checkBoxContainerDom = document.createElement("div");
          checkBoxContainerDom.className = "login-checkbox-container";
          const checkboxDom = document.createElement("input");
          checkboxDom.type = "checkbox";
          checkboxDom.className = "login-checkbox";
          checkboxDom.name = "login-checkbox";
          checkboxDom.style.width = "auto";
          const labelDom = document.createElement("label");
          labelDom.htmlFor = "login-checkbox";
          labelDom.setAttribute("for", "login-checkbox");
          labelDom.innerHTML = '\u5DF2\u9605\u8BFB\u5E76\u540C\u610F<a class="uc-login-text" href="https://chuhaiyi.baidu.com/agrt/service" target="_blank">\u300A\u5546\u5BB6\u670D\u52A1\u534F\u8BAE\u300B</a>\u3001<a class="uc-login-text" href="https://chuhaiyi.baidu.com/agrt/privacy" target="_blank">\u300A\u9690\u79C1\u653F\u7B56\u300B</a>\u548C<a class="uc-login-text" href="https://chuhaiyi.baidu.com/agrt/dataprocessing" target="_blank">\u300A\u6570\u636E\u5904\u7406\u89C4\u5219\u8BF4\u660E\u53CA\u5408\u89C4\u8981\u6C42\u300B</a>';
          checkBoxContainerDom.appendChild(checkboxDom);
          checkBoxContainerDom.appendChild(labelDom);
          (_a2 = loginActionBtnDom == null ? void 0 : loginActionBtnDom.parentNode) == null ? void 0 : _a2.insertBefore(checkBoxContainerDom, loginActionBtnDom);
        },
        beforeSubmit: () => {
          const checkbox = document.querySelector(".login-checkbox-container .login-checkbox");
          if (!(checkbox == null ? void 0 : checkbox.checked)) {
            checkbox.classList.add("login-checkbox-trembling");
            setTimeout(() => {
              checkbox.classList.remove("login-checkbox-trembling");
            }, 300);
            return false;
          }
          return true;
        }
      });
    };
    const handleLoginClick = async () => {
      emit("request-login");
      if (!(window == null ? void 0 : window.ucCommonLogin)) {
        await initLogin();
      }
      showUcCommonLoginDialog();
    };
    const handleLogoutClick = () => {
      var _a, _b;
      emit("request-logout");
      if (props.loginType === "passport") {
        logoutSaasAndPassport(!!((_a = ucCommonConfig.value) == null ? void 0 : _a.isProd));
      } else {
        logoutUcAndSaas(!!((_b = ucCommonConfig.value) == null ? void 0 : _b.isProd));
      }
    };
    onMounted(() => {
      initLogin();
    });
    return {
      handleLoginClick,
      handleLogoutClick
    };
  }
});
const _hoisted_1 = { class: "t-bms-user-menu" };
const _hoisted_2 = {
  key: 0,
  class: "t-bms-user-menu__wrapper"
};
const _hoisted_3 = { class: "t-bms-user-menu__username" };
const _hoisted_4 = {
  key: 0,
  class: "t-bms-user-menu-popver__head saas"
};
const _hoisted_5 = /* @__PURE__ */ createElementVNode("div", { class: "t-bms-user-menu-popver__head-title" }, "\u5546\u5BB6\u540E\u53F0", -1);
const _hoisted_6 = ["href"];
const _hoisted_7 = /* @__PURE__ */ createElementVNode("span", null, "\u8FDB\u5165\u5E73\u53F0", -1);
const _hoisted_8 = { class: "t-bms-user-menu-popver__head buy" };
const _hoisted_9 = /* @__PURE__ */ createElementVNode("div", { class: "t-bms-user-menu-popver__head-title" }, "\u5546\u5BB6\u540E\u53F0", -1);
const _hoisted_10 = ["href"];
const _hoisted_11 = /* @__PURE__ */ createTextVNode(" \u53BB\u8D2D\u4E70");
const _hoisted_12 = { class: "t-bms-user-menu-popver__opts" };
const _hoisted_13 = ["href"];
const _hoisted_14 = /* @__PURE__ */ createTextVNode(" \u6211\u7684\u8BA2\u5355");
const _hoisted_15 = {
  key: 0,
  class: "uncompleted-count"
};
const _hoisted_16 = ["href"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_arrow_down = resolveComponent("arrow-down");
  const _component_el_badge = resolveComponent("el-badge");
  const _component_arrow_right_bold = resolveComponent("arrow-right-bold");
  const _component_el_popover = resolveComponent("el-popover");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    !_ctx.isLogin ? (openBlock(), createElementBlock("div", _hoisted_2, [
      createElementVNode("div", {
        class: "t-bms-user-menu__sing-in-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleLoginClick && _ctx.handleLoginClick(...args))
      }, "\u767B\u5F55"),
      renderSlot(_ctx.$slots, "header")
    ])) : (openBlock(), createBlock(_component_el_popover, {
      key: 1,
      placement: "bottom",
      width: 160,
      trigger: "hover",
      "popper-class": "t-bms-user-menu-popver",
      "show-arrow": false,
      "hide-after": 50
    }, {
      reference: withCtx(() => [
        createVNode(_component_el_badge, {
          "is-dot": _ctx.uncompletedCount > 0,
          class: "t-bms-user-menu__notice-dot"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_3, [
              createTextVNode(toDisplayString(_ctx.name), 1),
              createVNode(_component_arrow_down)
            ])
          ]),
          _: 1
        }, 8, ["is-dot"])
      ]),
      default: withCtx(() => [
        _ctx.hasSaas ? (openBlock(), createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          createElementVNode("a", {
            target: "_blank",
            href: _ctx.saasLink,
            class: "t-bms-user-menu-popver__head-btn"
          }, [
            _hoisted_7,
            createVNode(_component_arrow_right_bold)
          ], 8, _hoisted_6)
        ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createCommentVNode(" \u5546\u5BB6\u5E73\u53F0\u5165\u53E3 "),
          createCommentVNode(" \u8D2D\u4E70\u5165\u53E3 "),
          createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            !_ctx.isFreeAccount ? (openBlock(), createElementBlock("a", {
              key: 0,
              target: "_blank",
              href: _ctx.buyLink,
              class: "t-bms-user-menu-popver__head-btn"
            }, [
              _hoisted_11,
              createVNode(_component_arrow_right_bold)
            ], 8, _hoisted_10)) : createCommentVNode("v-if", true)
          ])
        ], 2112)),
        createElementVNode("ul", _hoisted_12, [
          !_ctx.isFreeAccount ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("li", null, [
              createElementVNode("a", {
                target: "_blank",
                href: _ctx.myOrderLink
              }, [
                _hoisted_14,
                _ctx.uncompletedCount > 0 ? (openBlock(), createElementBlock("span", _hoisted_15, toDisplayString(_ctx.uncompletedCount), 1)) : createCommentVNode("v-if", true)
              ], 8, _hoisted_13)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.myCustomizeLink, (linkItem) => {
              return openBlock(), createElementBlock("li", {
                key: linkItem.href
              }, [
                createElementVNode("a", {
                  target: "_blank",
                  href: linkItem.href
                }, toDisplayString(linkItem.text), 9, _hoisted_16)
              ]);
            }), 128))
          ], 64)) : createCommentVNode("v-if", true),
          createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleLogoutClick && _ctx.handleLogoutClick(...args))
          }, "\u9000\u51FA\u767B\u5F55")
        ])
      ]),
      _: 1
    }))
  ]);
}
var BmsUserMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/bms-user-menu/src/bms-user-menu.vue"]]);

export { BmsUserMenu as default };
//# sourceMappingURL=bms-user-menu.vue2.js.map
